import { Divider as MuiDivider } from '@mui/material';
import type { DividerProps as MuiDividerProps } from '@mui/material';

/** Thin horizontal/vertical divider. Based on MUI Divider: https://mui.com/material-ui/react-divider/ */
export const Divider = (props: MuiDividerProps) => <MuiDivider {...props} />;
